module.exports = __webpack_public_path__ + "img/ogp_drawThings_big.151ef69b.jpg";